import { NavItem, NavLink } from 'reactstrap';
import useSession from '../../hooks/stateHooks/useSession';
import './MenuStyle.css';

function MenuOptionComponent(props) {
    const sessionHK = useSession();

    return (
        <NavItem className={sessionHK.isLogged() | !props.requireSession ? "" : "hidden-style" }>
            <NavLink href={props.href}>
                {props.value}
            </NavLink>
        </NavItem>
    );
}

export default MenuOptionComponent;